module.exports = __webpack_public_path__ + "static/media/ibm_logo.c96898ca.svg";